import styled from 'styled-components';

export const Wrapper = styled.div``;
Wrapper.displayName = 'Wrapper';

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  & > * {
    margin-bottom: 20px;
  }
`;
Fields.displayName = 'Fields';
